// eslint-disable-next-line
import { injectable } from "inversify";
import { rootContainer, TYPE } from "../container/root";
import { IApiResponse, IHttpService } from "../http-service";
import { IOption } from "../../components/inputs/select-dropdown/select-dropdown";
import { IFileData } from "../../components/file-upload/file-upload";
import {WithOld} from "../../stores/types";

export interface ILocaleItem {
    locale: string;
    is_enabled: boolean;
    is_default: boolean;
    locale_status: LocaleStatus;
}

export interface ILocaleService {
    fetchShopLocales: () => Promise<ILocaleItem[]>;
    getSelectLocalesList(): Promise<IOption[]>;
}

export enum LocaleStatus {
    CUSTOMIZED = "Customized",
    SYSTEM_DEFAULT = "System default",
    NO_TRANSLATIONS = "No translations",
    MISSING_TRANSLATIONS = 'Missing translations',
}

@injectable()
class LocalesService implements ILocaleService{
    private readonly httpService: IHttpService = rootContainer.get<IHttpService>(TYPE.ApiHttp);
    
    public async fetchShopLocales(): Promise<ILocaleItem[]> {
        const res = await this.httpService.get<IApiResponse<ILocaleItem[]>>('/rms-api/locales/get-locales');
        return res.payload;
    }

    public async getSelectLocalesList(): Promise<IOption[]> {
        const res = await this.httpService.get<IApiResponse<IOption[]>>('/rms-api/locales/select-locales');
        return res.payload;
    }

    public async downloadTranslations(): Promise<string> {
        const res = await this.httpService.get<IApiResponse<string>>('/rms-api/locales/download');
        return res.payload;
    }

    public async handleSave(data: WithOld<{ payload: ILocaleItem[] }, 'payload'>): Promise<ILocaleItem[]> {
        const res = await this.httpService.post<IApiResponse<ILocaleItem[]>>('/rms-api/locales/save', data);
        return res.payload;
    } 

    public async handleDelete(data: { payload: { locale: string }, __old: ILocaleItem[] }): Promise<ILocaleItem[]> {
        const res = await this.httpService.post<IApiResponse<ILocaleItem[]>>('/rms-api/locales/delete', data);
        return res.payload;
    }

    public async addLocales(locales: string[]): Promise<ILocaleItem[]> {
        const data = {'locales': locales}
        const res = await this.httpService.post<IApiResponse<ILocaleItem[]>>('/rms-api/locales/add-multiple', data);
        return res.payload;
    }

    public async uploadTranslationsFile(data: IFileData): Promise<ILocaleItem[]> {
        const res = await this.httpService.post<IApiResponse<ILocaleItem[]>>('/rms-api/locales/upload', data);
        return res.payload;
    }

}

export default LocalesService;